import React, { Component } from "react";

import Button from "@material-ui/core/Button";
import Fade from '@material-ui/core/Fade';
import Grid from "@material-ui/core/Grid";
import LinearProgress from '@material-ui/core/LinearProgress';
import Paper from '@material-ui/core/Paper';
import TextField from "@material-ui/core/TextField";
import Typography from '@material-ui/core/Typography';

import { Auth } from "aws-amplify";
import { withFormik } from "formik";
import * as Yup from "yup";
import logo from "../images/logo.png";

class ForgotPassword extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: "",
      getCode: false,
      failed: false,
      changingPassword: false,
      errorMessage: "",
      validateCalled: false,
      submittedEmail: null
    };
  }

  handleChange = name => e => {
    this.setState({ [name]: e.target.value });
  };

  onFormSubmit = async e => {
    e.preventDefault();
    try {
      this.setState({ changingPassword: true, errorMessage: "" });
      e.preventDefault();
      const result = await this.props.validateForm();
      this.setState({ validateCalled: true });
      console.log(result);
      if (this.props.isValid) {
        if (!this.props.values.getCode) {
          console.log("hello");
          let { email } = this.props.values;
          console.log(email);
          await Auth.forgotPassword(email);
          this.setState(
            { validateCalled: false, changingPassword: false },
            () => this.props.setFieldValue("getCode", true)
          );
        } else {
          // Collect confirmation code and new password, then
          let { email, code, newPassword } = this.props.values;
          await Auth.forgotPasswordSubmit(email, code, newPassword);
          this.setState({ changingPassword: false });
          this.props.history.goBack()
        }
      }else this.setState({ changingPassword: false})
    } catch (err) {
      this.setState({ changingPassword: false });
      console.log(err);
      if (err.code === "UserNotFoundException")
        this.setState({ errorMessage: "User not found" });
      else this.setState({ errorMessage: err.message });
    }
  };

  goBackToEmail = () => {
    this.setState({ errorMessage: "",validateCalled: true })
    this.props.setValues({
      getCode: false,
      newPassword: "",
      confirmPassword: "",
      code: "",
      email: this.props.values.email
    })
    this.props.setTouched({
      getCode: false,
      newPassword: false,
      confirmPassword: false,
      code: false
    })
    this.props.setErrors({
      getCode: "",
      newPassword: "",
      confirmPassword: "",
      code: ""
    })
  };

  render() {
    const { validateCalled } = this.state;
    const {
      handleChange,
      handleBlur,
      errors,
      values,
      touched,
      isValidating
    } = this.props;
    return (
      <Grid
        container
        alignItems="center"
        justify="center"
        style={{ height: "auto", marginTop: "60px" }}
      >
        <Grid item xs={6} md={4}>
          <Paper>
            {this.state.changingPassword ? (
              <LinearProgress
                variant="indeterminate"
                color="primary"
                style={{ height: 2 }}
              />
            ) : null}
            <div style={{ padding: "20px 20px 50px" }}>
              <div style={{ textAlign: "center" }}>
                <img
                  src={logo}
                  height={150}
                  style={{ display: "inline-block" }}
                  alt=""
                />
              </div>
              <Typography
                variant="h4"
                style={{
                  textAlign: "center",
                  fontWeight: 300,
                  fontWeight: "400"
                }}
              >
                Forgot password
              </Typography>
              <Typography
                variant="h6"
                style={{ textAlign: "center", fontWeight: 300 }}
              >
                Please enter the required fields.
              </Typography>
              <Typography
                variant="subtitle1"
                style={{ color: "#e74c3c", fontStyle: "italic" }}
                component="span"
              >
                {this.state.errorMessage}
              </Typography>
              <form onSubmit={this.onFormSubmit}>
                {!values.getCode ? (
                  <TextField
                    autoComplete="off"
                    id="email"
                    helperText={
                      (touched.email || validateCalled) && errors.email
                    }
                    error={(touched.email || validateCalled) && errors.email}
                    value={values.email}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    label="Email"
                    margin="normal"
                    variant="outlined"
                    fullWidth
                  />
                ) : (
                  <div>
                    <TextField
                      autoComplete="off"
                      id="newPassword"
                      helperText={
                        (touched.newPassword || validateCalled) &&
                        errors.newPassword
                      }
                      error={
                        (touched.newPassword || validateCalled) &&
                        errors.newPassword
                      }
                      value={values.newPassword}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      label="New password"
                      type="password"
                      margin="normal"
                      variant="outlined"
                      fullWidth
                    />
                    <TextField
                      autoComplete="off"
                      id="confirmPassword"
                      helperText={
                        (touched.confirmPassword || validateCalled) &&
                        errors.confirmPassword
                      }
                      error={
                        (touched.confirmPassword || validateCalled) &&
                        errors.confirmPassword
                      }
                      value={values.confirmPassword}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      label="Confirm Password"
                      type="password"
                      margin="normal"
                      variant="outlined"
                      fullWidth
                    />
                    <TextField
                      autoComplete="off"
                      id="code"
                      helperText={
                        (touched.code || validateCalled) && errors.code
                      }
                      error={(touched.code || validateCalled) && errors.code}
                      value={values.code}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      label="Verification code"
                      margin="normal"
                      variant="outlined"
                      fullWidth
                    />
                  </div>
                )}

                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "flex-end",
                    marginTop: 30
                  }}
                >
                  <Fade in={values.getCode} timeout={{ enter: 500, exit: 500 }}>
                    <Button
                      variant="contained"
                      color="primary"
                      style={{ marginRight: 5 }}
                      onClick={this.goBackToEmail}
                    >
                      Back
                    </Button>
                  </Fade>
                  <Button
                    variant="contained"
                    color="primary"
                    type="submit"
                    style={{ marginLeft: 5 }}
                  >
                    {values.getCode ? "Submit" : "Next"}
                  </Button>
                </div>
              </form>
            </div>
          </Paper>
          <h5
            style={{
              bottom: 0,
              color: "#636e72",
              textAlign: "center",
              margin: "4px"
            }}
          >
            Built by the Web Development Team
          </h5>
          <h5
            style={{
              bottom: 0,
              color: "#636e72",
              textAlign: "center",
              margin: "4px"
            }}
          >
            &copy; DentistFind Inc.
          </h5>
        </Grid>
      </Grid>
    );
  }
}

export default withFormik({
  mapPropsToValues: props => {
    return {
      email: "",
      code: "",
      newPassword: "",
      confirmPassword: "",
      getCode: false
    };
  },
  validationSchema: Yup.object().shape({
    email: Yup.string()
      .email("Please give a valid email address")
      .required("Please provide your email address"),
    code: Yup.string().when("getCode", {
      is: true,
      then: Yup.string().required(
        "Please give us the verification code that we sent to you."
      )
    }),
    newPassword: Yup.string().when("getCode", {
      is: true,
      then: Yup.string()
        .required("Please enter your new password.")
        .matches(
          /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/,
          "Password must be at least 8 letters, uppercase, lowercase and numbers."
        )
    }),
    confirmPassword: Yup.string().when("getCode", {
      is: true,
      then: Yup.string()
        .oneOf([Yup.ref("newPassword"), null], "Password does not match!")
        .required("Please confirm the password!")
    })
  }),
  validateOnChange: true
})(ForgotPassword);
